import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export function Input({ className = '', style, ...props }) {
    return (_jsx("input", { className: `px-3 py-2 rounded border ${className}`, style: {
            backgroundColor: 'var(--bg-base)',
            color: 'var(--text-primary)',
            border: '1px solid var(--border-color)',
            outline: 'none',
            ...style
        }, ...props }));
}
